import { FunctionComponent } from 'react'
import styled from 'styled-components'

import * as T from 'types'

const getProvidingCompanyName = (listing: T.IListing) => {
  switch (listing.state) {
    case 'UT':
      return 'JDS Real Estate Services, Inc'
    case 'NJ':
      return 'HomeLister of NJ, Inc'
    default:
      return 'HomeLister, Inc'
  }
}

const Container = styled.div`
  padding: 10px 20px;
`

const StyledText = styled.div`
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
`

interface IProps {
  listing: T.IListing
}

const ListingProvidedBy: FunctionComponent<IProps> = ({ listing }) => (
  <Container>
    <StyledText>{`Listing provided by ${getProvidingCompanyName(listing)}`}</StyledText>
  </Container>
)

export default ListingProvidedBy
